
import { Component, Vue } from "vue-property-decorator";
import { SweetModal } from "sweet-modal-vue";
import stores from "@/stores";
import { showToaster } from "@/components/DashboardComposer/helpers";

@Component({ components: { SweetModal } })
export default class LogDetailsModal extends Vue {
  log: any = null;
  location: string = "Loading...";

  async open(logId: number) {
    const response = await stores.ActivityLog.getItem(logId);
    this.log = response.data;

    // Parse JSON fields if needed
    if (typeof this.log.old === "string") {
      try {
        this.log.old = JSON.parse(this.log.old);
      } catch {}
    }
    if (typeof this.log.new === "string") {
      try {
        this.log.new = JSON.parse(this.log.new);
      } catch {}
    }

    // Fetch location once log is loaded
    if (this.log?.properties?.ip) {
      this.location = await this.fetchLocation(this.log.properties.ip);
    } else {
      this.location = "N/A";
    }
    await this.$nextTick();
    (this.$refs.logModal as any)?.open();
  }

  async fetchLocation(ip: string) {
    try {
      const res = await fetch(`https://ipapi.co/${ip}/json/`);
      const data = await res.json();
      if (data && data.city && data.country_name) {
        return `${data.city}, ${data.country_name}`;
      } else {
        return "Unknown location";
      }
    } catch (e) {
      console.error("Failed to fetch location", e);
      return "N/A";
    }
  }

  formatDate(date: string) {
    return new Date(date).toLocaleString();
  }

  pretty(obj: any) {
    return obj ? JSON.stringify(obj, null, 2) : ".";
  }

  copyToClipboard(text: string) {
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(text)
        .then(() => {
          showToaster('success', 'Copied!', '');
        })
        .catch(() => {
          showToaster('danger', 'Failed to Copy!', '');
        });
    } else {
      // Fallback for older browsers
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      showToaster('success', 'Copied!', '');
    }
  }

  closeModal() {
    (this.$refs.logModal as any).close();
  }
}
